
require( './kovDatePicker.scss' );
require( './bootstrap-datepicker.js' );

let m = angular.module( 'kovDatePickerModule', [] );
m.component( 'kovDatePicker', require( './kovDatePicker.js' ) );

module.exports = 'kovDatePickerModule';